import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { ConstitucionDelCreditoCreditosConEmpleadosModel, CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { CreditosConEmpleadosListComponent } from './creditos-con-empleados-list.component';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-creditosconempleadosconstitucioncredito',
    templateUrl: './creditos-con-empleados-dialog-constitucion-credito.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosDialogConstitucionCreditoComponent implements OnInit {

  public creditosconempleados: CreditosConEmpleadosModel = this.data.creditosconempleados;

  public constitucionDelCreditoCreditosConEmpleados: ConstitucionDelCreditoCreditosConEmpleadosModel = new ConstitucionDelCreditoCreditosConEmpleadosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  public dataSource: ConstitucionDelCreditoCreditosConEmpleadosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'comisionApertura', title: 'Comisión Apertura', cell: (row) => `${row.comisionApertura}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidPlazo: boolean = false;
  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporte: boolean = false;
  public invalidBankAccount: boolean = false;

  public activities: ActivityModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreditosConEmpleadosListComponent>,
    public creditosConEmpleadosService: CreditosConEmpleadosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      });

    this.getData();
  }

  public pay(): void {
    // Asignamos el uid de la inversion al deposito
    this.constitucionDelCreditoCreditosConEmpleados.creditosConEmpleadosId = this.creditosconempleados.uid;

    let noError: boolean = true;

    // Validations
    if (this.constitucionDelCreditoCreditosConEmpleados.plazo == null || this.constitucionDelCreditoCreditosConEmpleados.plazo == 0) {
      noError = false;
      this.invalidPlazo = true;
    }

    if (this.constitucionDelCreditoCreditosConEmpleados.fecha == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.constitucionDelCreditoCreditosConEmpleados.concepto == null || this.constitucionDelCreditoCreditosConEmpleados.concepto == '') {
      noError = false;
      this.invalidConcept = true;
    }

    if (this.constitucionDelCreditoCreditosConEmpleados.importe == null || this.constitucionDelCreditoCreditosConEmpleados.importe == 0) {
      noError = false;
      this.invalidImporte = true;
    }

    if (this.constitucionDelCreditoCreditosConEmpleados.bankAccountsUid == null || this.constitucionDelCreditoCreditosConEmpleados.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.invalidBankAccount = true;
    }

    if (this.constitucionDelCreditoCreditosConEmpleados.activitiesUid == null) {
      noError = false;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.creditosConEmpleadosService.constitucionDelCreditoCreate(this.constitucionDelCreditoCreditosConEmpleados)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el elemento");
          });
      }
      if (this.isEditMode === true) {
        this.creditosConEmpleadosService.constitucionDelCreditoUpdate(this.constitucionDelCreditoCreditosConEmpleados)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el elemento");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }

  }

  public getData(): void {
    this.depositSaved = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporte = false;
    this.invalidBankAccount = false;
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.creditosConEmpleadosService.constitucionDelCreditoDelete(uidElement)
      .then(responseDelete => {
        this.getData();

        this.list = false;
        this.dataSource = [];

        this.creditosConEmpleadosService.constitucionDelCreditoList(this.creditosconempleados.uid, this.constitucionDelCreditoCreditosConEmpleados.plazo)
          .then(response => {
            this.dataSource = response;

            if (this.dataSource.length > 0) {
              this.list = true;
            }
          })
          .catch(error => {
          });

      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar la constitucion del credito");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;

    this.constitucionDelCreditoCreditosConEmpleados = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public plazoChangeValue(corto_largo_plazo_id: number) {
    this.list = false;
    this.dataSource = [];

    this.creditosConEmpleadosService.constitucionDelCreditoList(this.creditosconempleados.uid, corto_largo_plazo_id)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
      })
      .catch(error => {
      });
  }
  public trackByIndex(i: number) { return i; }

}
